import { render } from "./TaxInvoice.vue?vue&type=template&id=421dc71c&scoped=true"
import script from "./TaxInvoice.vue?vue&type=script&lang=js"
export * from "./TaxInvoice.vue?vue&type=script&lang=js"

import "./TaxInvoice.vue?vue&type=style&index=0&id=421dc71c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/colordemy-customers/colordemy-customers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-421dc71c"]])

export default __exports__